export default __webpack_public_path__ + "static/media/front.ac5d34c7.png";